import {
  Directive,
  ElementRef,
  Input,
  Output,
  EventEmitter,
  HostListener,
} from '@angular/core';

@Directive({
  selector: '[dsClickOutside]',
})
export class ClickOutsideDirective {
  constructor(private _elementRef: ElementRef) {}
  @Input() clickOutSideRefElement: Element;
  @Output()
  public dsClickOutside = new EventEmitter();

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement) {
    const clickedInside =
      this._elementRef.nativeElement.contains(targetElement) ||
      (this.clickOutSideRefElement != undefined &&
        this.clickOutSideRefElement.contains(targetElement));
    if (!clickedInside) {
      this.dsClickOutside.emit(null);
    }
  }
}
